/**
 * What hides a model in each code world (ADR-053), measured from the built world by apps/headset's
 * world-sight.test.ts (`WORLD_SIGHT_OUT=<this file>`), which also holds it to the worlds: never edit
 * by hand. `sight` is `encodeSight`'s text (world-package/measure.ts), `fog` the FogExp2 density,
 * `ground` `encodeGround`'s text of the land under the profile (null: flat at 0). A world is dropped
 * from here when its package takes it over.
 */
export const CODE_WORLD_SIGHT = {};
//# sourceMappingURL=world-sight.generated.js.map